module.exports = __webpack_public_path__ + "static/media/Lato-Hairline.ada4458b.woff2";